import CreationToolWelcomeButton from 'creation/src/creation-tools/types/welcome-button'
import type { ReactNode } from 'react'

type Props = {
    children?: ReactNode
    className?: string
    button: CreationToolWelcomeButton
}

/**
 * Legacy structural reference: components/welcome/buttons/button/link.tsx.
 * Only ever used for Super Cut today (the sole welcome button with a `url()`).
 */
const LinkButton = ({ children, className, button }: Props) => (
    <a href={CreationToolWelcomeButton.url(button)} className={className}>
        {children}
    </a>
)

export default LinkButton
